<template>
  <v-container fluid class="px-0 py-0 export-status-viewer">
    <template v-if="status == 'loadding'">
      <div class="center">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
      <div class="center">{{ cfg.loading || "正在生成下载，请稍后..." }}</div>
    </template>
    <template v-else-if="status == 'success'">
      <v-alert :value="true" type="success" outline>
        生成成功，可以直接点击下载
      </v-alert>
      <div class="center"><a :href="cfg.downUrl" target="_blank">下载</a></div>
    </template>
    <template v-else-if="status == 'error'">
      <v-alert :value="true" type="warning" outline>
        生成失败! {{ errMsg }}
      </v-alert>
    </template>
  </v-container>
</template>
<script>
export default {
  name: "export-status-viewer",
  props: {
    cfg: Object,
  },
  data() {
    return {
      status: "loadding",
      errMsg: "",
    };
  },
  watch: {
    cfg() {
      this.init();
    },
  },
  methods: {
    init() {
      let self = this,
        cfg = self.cfg;
      if (!cfg || !cfg.exeUrl) {
        return;
      }
      self.status = "loadding";
      self.errMsg = "";
      self.$axios.get(cfg.exeUrl).then((r) => {
        let data = r.data;
        if (data.status == 'ok') {
          if (data.task) {
            self.status = 'error';
            self.errMsg = data.message;
            self.$store.commit('rightDrawer', 'myTaskShow');
          } else {
            self.status = 'success';
          }
          return
        }
        self.status = "error";
        self.errMsg = data.message || '导出出现错误～';
      });
    },
  },
  created() {
    this.init();
  },
};
</script>
<style scoped>
.export-status-viewer .center {
  text-align: center;
  padding: 8px;
}
</style>